<template>
    <div class="top-page-banner" v-if="state.show">
        <div class="container">
            <div class="top-page-banner__inner flex v-center center">
                <div class="top-page-banner__text" v-html="params.text"></div>
                <ABtn :label="params.link.title" :href="params.link.url" fill="outlined" />
            </div>
        </div>
    </div>
</template>

<script>

import { ref } from 'vue'
import { ABtn } from './ui'

export default {
    name: 'TopPageBanner',
    components: {
        ABtn,
    },
    props: ['params'],
    setup: (props, ctx) => {

        const state = ref({
            show: props.params.show,
        })

        return {
            state,
        }
    },
}
</script>

<style lang="scss">
    .top-page-banner {
        height: 60px;
        background: var(--c-secondary-200);
        position: relative;
        z-index: 100;
        color: #fff;
        a {
            color: #fff;
        }
        &__inner {
            justify-content: center;
            width: 100%;
            height: 60px;
        }
        &__text {
            @include tablet {
                font-size: 12px;
            }
            @include mobile {
                font-size: 10px;
                line-height: 12px;
            }
        }
        .a-btn {
            height: 36px;
            max-height: 36px;
            margin-left: 22px;
            @include tablet {
                font-size: 12px;
                min-width: 110px;
            }
        }
    }
</style>